import React, { FC } from 'react';
import { BodyTextSmall, FlexCol, PaywallButton, TextDynamic } from '@minecraft.atoms';
import { getCurrentDateTime } from '@minecraft.date-utils';
import IconWithErrorBoundary from '@minecraft.icon';
import { useTranslation } from '@blocs.i18n';
import { CheckoutProps } from '../../Checkout/types';
import { priceFormatter } from '../../helpers/priceFormatter';

type Props = {
  completedPurchase?: CheckoutProps['completedPurchase'];
  onDone?: CheckoutProps['closeBillingPopup'];
};

export const ReactivateSuccess: FC<Props> = ({ completedPurchase, onDone }) => {
  const { t, formatIntlDate } = useTranslation();
  const price = priceFormatter({
    price: Number(completedPurchase?.total),
    currencyCode: completedPurchase?.currency?.code,
    t,
    roundingFloor: true,
  });

  return (
    <>
      <IconWithErrorBoundary name="check-circle" themeColor="goldPaywall" size="xlm" />
      <TextDynamic align="center" fontSize="h2" fontWeight="bold" color="inverted">
        {t('common:paywall.plan.reactivate-modal-complete.header')}
      </TextDynamic>
      <FlexCol w="full" justifyItems="center" alignItems="center" gap="2" data-testid="reactivation-charge-info">
        <BodyTextSmall color="inverted">
          {t('common:paywall.plan.charged_on', {
            price,
            date: formatIntlDate({ date: getCurrentDateTime(), format: 'MONTH_DAY_YEAR' }),
          })}
        </BodyTextSmall>
      </FlexCol>
      <PaywallButton label={t('common:button.done')} color="gold" onClick={onDone} full isSmall />
    </>
  );
};
